import client from "./client";

const FILES_BASE_PATH = "/api/v1/files";

const buildUploadPayload = (payload) => {
  if (payload instanceof FormData) {
    return payload;
  }

  const formData = new FormData();
  if (payload instanceof File) {
    formData.append("file", payload);
    return formData;
  }

  if (payload && typeof payload === "object") {
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
  }

  return formData;
};

export async function uploadConfigFile(payload) {
  const res = await client.post(`${FILES_BASE_PATH}/config`, buildUploadPayload(payload), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function uploadDatasetFile(payload) {
  const res = await client.post(`${FILES_BASE_PATH}/dataset`, buildUploadPayload(payload), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function listMyFiles({ file_type, limit = 50, offset = 0 } = {}) {
  const res = await client.get(FILES_BASE_PATH, {
    params: {
      file_type,
      limit,
      offset,
    },
  });
  return res.data;
}

export async function getFileTask(taskId) {
  const res = await client.get(`${FILES_BASE_PATH}/tasks/${taskId}`);
  return res.data;
}

export async function getFile(fileId) {
  const res = await client.get(`${FILES_BASE_PATH}/${fileId}`);
  return res.data;
}

export async function deleteFile(fileId) {
  await client.delete(`${FILES_BASE_PATH}/${fileId}`);
}

export async function activateFile(fileId, fileType) {
  const res = await client.post(`${FILES_BASE_PATH}/${fileId}/activate`, null, {
    params: { file_type: fileType },
  });
  return res.data;
}
